import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";

export class DailyQuestConfig extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;

        this._easy = 0;
        this._hard = 0;
        this._medium = 0;

        this._guard = new GuardConfig();
        this._reward = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get easy() {
        return this._easy;
    }

    set easy(value) {
        this._easy = value;
    }

    get hard() {
        return this._hard;
    }

    set hard(value) {
        this._hard = value;
    }

    get medium() {
        return this._medium;
    }

    set medium(value) {
        this._medium = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (!Number.isInteger(this.easy) || this.easy < 0) {
            return false;
        }

        if (!Number.isInteger(this.hard) || this.hard < 0) {
            return false;
        }

        if (!Number.isInteger(this.medium) || this.medium < 0) {
            return false;
        }

        if((this.easy + this.medium + this.hard) <=0){
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new DailyQuestConfig());
        } else if (target instanceof DailyQuestConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(DailyQuestConfig, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),

    _easy: alias("orders_easy", Schema.primitive()),
    _hard: alias("orders_hard", Schema.primitive()),
    _medium: alias("orders_medium", Schema.primitive()),

    _guard: alias("guard", GuardConfig.schema()),
    _reward: alias("reward", RewardBunch.schema()),
});